// API Keys - In a production environment, these should be stored in environment variables
export const OPENAI_API_KEY = process.env.REACT_APP_OPENAI_API_KEY || '';

// URLs
export const RECHARGE_URL = 'https://recharge.green-tokens.com';

// Local Storage Keys
export const STORAGE_KEYS = {
  RECIPES: 'recipes',
  USER_PREFERENCES: 'userPreferences',
  REMEMBER_ME: 'rememberMe',
  EMAIL: 'email',
  // PASSWORD: Removed for security - passwords should NEVER be stored in localStorage
  IS_FIRST_RUN: 'isFirstRun',
  WELCOME_TOUR_COMPLETED: 'welcomeTourCompleted',
  DISMISSED_NOTES: 'dismissedNotes',
  IMAGE_GENERATION: 'imageGeneration',
  AUDIO_GENERATION: 'audioGeneration',
  VOICE_TYPE: 'voiceType',
  IMAGE_STYLE: 'imageStyle',
  IMAGE_MODEL: 'imageModel',
  TEXT_MODEL: 'textModel',
  VOICE_MODEL: 'voiceModel',
  AUTO_IMAGE: 'autoImage',
  AUTO_SPEECH: 'autoSpeech',
};

// Sample Recipe Data - Start with empty array
export const SAMPLE_RECIPES: any[] = [];

// Animation Durations
export const ANIMATION = {
  FAST: 0.2,
  NORMAL: 0.5,
  SLOW: 0.8,
};

// Theme Colors - Food-Inspired Palette
export const COLORS = {
  // Primary warm oranges - chef/cooking inspired
  PRIMARY: '#FF6B35', // Vibrant chef orange
  PRIMARY_LIGHT: '#FF8A65', // Light chef orange
  PRIMARY_DARK: '#E64100', // Dark chef orange
  
  // Secondary herb greens - fresh ingredient inspired
  SECONDARY: '#4A7C59', // Deep herb green
  SECONDARY_LIGHT: '#6B9B7B', // Light sage green
  SECONDARY_DARK: '#2E4D3A', // Dark forest green
  
  // Neutral cooking colors
  WARM_WHITE: '#FFF8F3', // Warm cooking background
  CREAM: '#F5F2ED', // Light cream surface
  WARM_GRAY: '#8D7B68', // Warm neutral gray
  
  // Status colors
  SUCCESS: '#6B9B7B', // Herb green for success
  ERROR: '#C62828', // Deep red for errors
  WARNING: '#FF8F00', // Amber for warnings
  INFO: '#1976D2', // Blue for information
  
  // Legacy colors for compatibility
  LIGHT: '#FFF8F3',
  DARK: '#2C1810', // Dark cooking environment
};

// Routes
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  RECIPES: '/recipes',
  RECIPE_DETAIL: '/recipes/:id',
  RECIPE_STEPS: '/recipes/:id/steps/:stepIndex',
  RECIPE_CAPTURE: '/capture',
  RECIPE_EDIT: '/recipes/:id/edit',
  SETTINGS: '/settings',
  HELP: '/help',
  ABOUT: '/about',
};
